import locationService from '@/api/location'
import { LOCATION } from '../types'
import utils from '@/utils/utils'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    locations: [],
    locationsGroupedBySite: [],
    locationsFreeroom: [],
    locationSiteId: null,
    devicesIds: [],
    blockAccessUponPriorBooking: false,
    locationsWithSensor: []
  },
  getters: {
    siteLocations: (state) => {
      return state.locationsGroupedBySite.length > 0 && state.locationSiteId ? state.locationsGroupedBySite.find(site => site.id == state.locationSiteId)?.locations : []
    },
    locationSiteId: (state) => {
      return state.locationSiteId
    },
    getDevicesIds: (state) => {
      return state.devicesIds
    },
    getLocationDevicesBlockAccess: (state) => {
      return state.blockAccessUponPriorBooking
    }
  },
  mutations: {
    [LOCATION.SET_LOCATIONS](state, locations) {
      state.locations = locations
    },
    [LOCATION.SET_LOCATIONS_GROUPED_BY_SITE](state, locationsGroupedBySite) {
      state.locationsGroupedBySite = locationsGroupedBySite
    },
    [LOCATION.SET_LOCATIONS_FREEROOM](state, locationsFreeroom) {
      state.locationsFreeroom = locationsFreeroom
    },
    [LOCATION.SET_SITE_ID](state, locationSiteId) {
      state.locationSiteId = locationSiteId
    },
    [LOCATION.SET_LOCATION_DEVICES](state, devicesIds) {
      state.devicesIds = devicesIds
    },
    [LOCATION.SET_LOCATION_DEVICES_BLOCK_ACCESS](state, blockAccessUponPriorBooking) {
      state.blockAccessUponPriorBooking = blockAccessUponPriorBooking
    },
    [LOCATION.SET_LOCATIONS_WITH_SENSORS](state, locationsWithSensor) {
      state.locationsWithSensor = locationsWithSensor
    }
  },
  actions: {
    getLocationsList({ commit, dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        locationService.getLocations().then((response) => {
          dispatch('Global/hideLoading', null, { root: true })
          commit(LOCATION.SET_LOCATIONS, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    getLocationsGroupedBySite({ commit, dispatch }, clientId) {
      return new Promise((resolve, reject) => {
        locationService.getLocationsGroupedBySite(clientId).then((response) => {
          commit(LOCATION.SET_LOCATIONS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    getInitialLocationsGroupedBySite({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        locationService.getInitialLocationsGroupedBySite().then((response) => {
          commit(LOCATION.SET_LOCATIONS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    getInitialLocationsFreeroom({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        locationService.getInitialLocationsFreeroom().then((response) => {
          commit(LOCATION.SET_LOCATIONS_FREEROOM, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    async addLocation({ dispatch }, location) {
      try {
        await locationService.addLocations(location)
        dispatch('getLocationsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editLocation({ dispatch }, location) {
      try {
        await locationService.editLocations(location)
        dispatch('getLocationsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async downloadLocationMap({ dispatch }, locationId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await locationService.getLocationMap(locationId)
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        dispatch('Global/hideLoading', null, { root: true })
        utils.handleDownload(blob, 'location_map.svg')
      } catch (e) {
        let error = e.response.data.error.errors[0]
        dispatch('Global/hideLoading', null, { root: true })
        if (error.reason === 'blobFileNotFound') {
          dispatch('Global/showMessage', 'blobFileNotFound', { root: true })
        } else {
          dispatch('Global/showMessage', 'errorDefault', { root: true })
        }
      }
    },
    setLocationSiteId({ commit }, locationSiteId) {
      commit(LOCATION.SET_SITE_ID, locationSiteId)
    },
    async getLocationDevices({ commit, dispatch }, locationId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await locationService.getLocationDevices(locationId)
        commit(LOCATION.SET_LOCATION_DEVICES, response.data.devices ? response.data.devices : [])
        commit(LOCATION.SET_LOCATION_DEVICES_BLOCK_ACCESS, response.data.blockAccessUponPriorBooking)
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async saveLocationDevices({ dispatch }, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await locationService.saveLocationDevices(payload.workPlaceId, payload.devicesIds, payload.blockAccessUponPriorBooking)
        dispatch('Global/showMessage', 'saveSucessful', { root: true })
        await dispatch('getLocationDevices', payload.locationId)
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async activateLocal(_, locationId) {
      try {
        await locationService.activateLocal(locationId)
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      }
    },
    async deactivateLocal({ dispatch }, params) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await locationService.deactivateLocal(params.locationId, params.cancelFutureBookings)
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getIntegration({ dispatch }, locationId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await locationService.getIntegration(locationId)
        return response
      }
      catch (error) {
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async saveIntegration({ dispatch }, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await locationService.saveIntegration(payload.locationId, payload.integration)
        dispatch('Global/showMessage', 'saveSucessful', { root: true })
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    getSensorsWithLocation({ commit }) {
      return new Promise((resolve) => {
        locationService.getSensorsWithLocation().then((response) => {
          commit(LOCATION.SET_LOCATIONS_WITH_SENSORS, response.data)
          resolve()
        })
      })
    }
  }
}
